/* global $ */

const $enrollDate = $('.js-enroll-date');
const $enrollDateBtn = $('.js-enroll-date-btn');
const $enrollDateOutput = $('.js-enroll-date-output');

const enrollDate = {
  initialize() {
    if ($enrollDate.length) {
      this.createEvents();
    }
  },

  /**
   * Create events for the enroll date modal and input fields
   * @return {void}
   */
  createEvents() {
    // Listen for clicks on the new date button in the modal
    $enrollDateBtn.on('click', (e) => {
      // Get information to put back in the form
      const { target, val, input } = $(e.currentTarget).data();
      const $target = $(target);

      // Select the correction option in the select box
      if ($target.length) {
        $target.val(val);
      }

      // Output content on the page (like date, time and location)
      Object.keys(input).forEach((key) => {
        const dataVal = input[key];
        const $dataTarget = $enrollDateOutput.filter(`[data-output="${key}"]`);

        if ($dataTarget.length) {
          $dataTarget.html(dataVal);
        }
      });

      $enrollDate.modal('hide');
    });
  },
};

export default enrollDate;
